'use client'
import Modal from '@crystal-eyes/components/elements/Modal'
import styles from './AssessmentModal.module.scss'
import useTakingAssessment from '../hooks/useTakingAssessment'
import Assessment from '@crystal-eyes/components/views/assessment/Assessment'
import useValues from '@crystal-eyes/hooks/assessments/useValues'
import useStrengths from '@crystal-eyes/hooks/assessments/useStrengths'
import useMbti from '@crystal-eyes/hooks/assessments/useMbti'
import useBigFive from '@crystal-eyes/hooks/assessments/useBigFive'
import useEnneagram from '@crystal-eyes/hooks/assessments/useEnneagram'
import { assessmentInfo } from '@crystal-eyes/lib/assessments'

interface Identity {
  id: string
}

type Props = { identity?: Identity }

export default function AssessmentModal({ identity }: Props) {
  const {
    assessmentState: {
      taking: takingAssessment,
      setTaking: setTakingAssessment,
    },
  } = useTakingAssessment()
  const { data: valuesData } = useValues({ identity })
  const { data: strengthData } = useStrengths({ identity })
  const { data: mbtiData } = useMbti({ identity })
  const { data: bigFiveData } = useBigFive({ identity })
  const { data: enneagramData } = useEnneagram({ identity })

  const assessmentData = {
    values: valuesData,
    strengths: strengthData,
    mbti: mbtiData,
    bigFive: bigFiveData,
    enneagram: enneagramData,
  }

  if (takingAssessment === 'none') return null

  const isMbti = takingAssessment === 'mbti'

  return (
    <Modal
      className={styles.assessmentModal}
      close={() => {
        setTakingAssessment('none')
      }}
    >
      <Assessment
        assessmentContext={assessmentInfo[takingAssessment]}
        data={assessmentData[takingAssessment]}
        onFinish={() => {
          setTakingAssessment('none')
        }}
        line={isMbti}
        customStyleOption={isMbti ? styles.mbtiOption : undefined}
        customStyleContainer={isMbti ? styles.mbtiOptionContainer : undefined}
      />
    </Modal>
  )
}
